
export default class BankAccountChangeActualBankBalanceRequestModel {
    public actualBankBalance: number = 0;
    public actualBankBalanceAsOfDate?: Date;
}
